import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", { d: "M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z", fill: "#333333" })));
export {
  l as default
};
